import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { BrapiSyncComponent } from './brapi-sync.component';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ConnectionsComponent } from './connections/connections.component';
import { BRAPI_SYNC_ROUTES } from './app.route';
import { ProgramComponent } from './program/program.component';
import { GermplasmComponent } from './germplasm/germplasm.component';
import { NgbPaginationModule, NgbToastModule } from '@ng-bootstrap/ng-bootstrap';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { AuthInterceptor } from './auth.interceptor';
import { EntitySelectorComponent } from './entity-selector/entity-selector.component';
import { CollapsibleComponent } from './shared/collapsible/collapsible.component';
import { TrialComponent } from './trial/trial.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxJsonViewerModule } from 'ngx-json-viewer';
import { ExpandableJsonViewerComponent } from './shared/expandable-json-viewer/expandable-json-viewer.component';
import { StudyComponent } from './study/study.component';
import { ObservationUnitComponent } from './observation-unit/observation-unit.component';
import { VariableComponent } from './variable/variable.component';
import { ObservationComponent } from './observation/observation.component';
import { ObjectKeysPipe } from './shared/pipes/object-keys.pipe';
import { StudySelectorComponent } from './shared/study-selector/study-selector.component';
import { StudyFilterComponent } from './shared/study-selector/study-filter.component';
import { DropdownVirtualScrollComponent } from './shared/dropdown-virtual-scroll/dropdown-vritual-scroll.component';
import { GermplasmSourceModalComponent } from './germplasm/germplasm-source-modal.component';
import { StudiesService } from './shared/brapi/2.1/api/studies.service';
import { PedigreeService } from './shared/brapi/2.1/api/pedigree.service';
import { GermplasmService } from './shared/brapi/2.0/api/germplasm.service';
import { PedigreeGraphComponent } from './shared/pedigree-graph/pedigree-graph.component';
import { GermplasmPedigreeGraphModalComponent } from './germplasm/germplasm-pedigree-graph-modal.component';
import { PedigreeUtilService } from './shared/pedigree/pedigree-util.service';
import { BrapiSyncService } from './brapi-sync.service';
import { BmsjHipsterSharedModule } from '../shared';
import { CoreUtilsModule } from '../shared/core-utils';

@NgModule({
    declarations: [
        BrapiSyncComponent,
        ConnectionsComponent,
        ProgramComponent,
        GermplasmComponent,
        StudyFilterComponent,
        EntitySelectorComponent,
        CollapsibleComponent,
        TrialComponent,
        ExpandableJsonViewerComponent,
        StudyComponent,
        ObservationUnitComponent,
        VariableComponent,
        ObservationComponent,
        ObjectKeysPipe,
        StudySelectorComponent,
        DropdownVirtualScrollComponent,
        GermplasmSourceModalComponent,
        PedigreeGraphComponent,
        GermplasmPedigreeGraphModalComponent
    ],
    imports: [
        BrowserModule,
        FormsModule,
        RouterModule.forChild(BRAPI_SYNC_ROUTES),
        NgbPaginationModule,
        HttpClientModule,
        NgSelectModule,
        NgxJsonViewerModule,
        NgbToastModule,
        BmsjHipsterSharedModule,
        CoreUtilsModule
    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        },
        StudiesService,
        GermplasmService,
        PedigreeService,
        PedigreeUtilService,
        BrapiSyncService
    ]
})
export class BrapiSyncModule {

    constructor() {
    }

}
